import qs from "qs";
import axios from "axios";
import { URL } from "../../../../constants/Constants";

/**
 * Inserta nueva calidad de trabajo múltiple
 * @param {string} Trabajo - Tipo de trabajo
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @param {string} name - Nombre del usuario
 * @param {string} team - Equipo
 * @param {string} incidencia - Incidencia
 * @param {string} solucion - Solución
 * @param {string} proceso_tipo - Tipo de proceso
 * @param {string} tipo_tiempo - Tipo de tiempo
 * @param {number} cantidad_total - Cantidad total
 * @param {number} cantidad_ok - Cantidad OK
 * @param {number} cantidadIncidencia - Cantidad de incidencias
 * @param {string} typeConnect - Tipo de conexión
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} cod_team - Código del equipo
 * @param {string} codigo - Código
 * @param {string} fecha_ini_calidad - Fecha de inicio de calidad
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const InserNewQualityMultiwork = async (
  Trabajo,
  po,
  mo,
  name,
  team,
  incidencia,
  solucion,
  proceso_tipo,
  tipo_tiempo,
  cantidad_total,
  cantidad_ok,
  cantidadIncidencia,
  typeConnect,
  currentScreenId,
  cod_team,
  codigo,
  fecha_ini_calidad
) => {
  let queryData;
  if (Trabajo === "CALIDADCONERRORES") {
    queryData = {
      tipo_trabajo: Trabajo,
      po: po,
      mo: mo,
      usuario: name,
      team: team,
      incidencia: incidencia,
      solucion: solucion,
      proceso: proceso_tipo,
      tipo_tiempo: tipo_tiempo,
      cantidad_total: cantidad_total,
      cantidad_ok: cantidad_ok - cantidadIncidencia,
      cantidadIncidencia: cantidadIncidencia,
      action: typeConnect,
      query_type: currentScreenId,
      codigoProceso: codigo,
      codigo: cod_team,
      fecha_ini_calidad: fecha_ini_calidad,
    };
  } else if (Trabajo === "CALIDADCORRECTA") {
    queryData = {
      tipo_trabajo: Trabajo,
      po: po,
      mo: mo,
      usuario: name,
      team: team,
      incidencia: incidencia,
      solucion: solucion,
      proceso: proceso_tipo,
      tipo_tiempo: tipo_tiempo,
      cantidad_total: cantidad_total,
      cantidad_ok: cantidad_ok,
      cantidadIncidencia: cantidadIncidencia,
      action: typeConnect,
      query_type: currentScreenId,
      codigoProceso: codigo,
      codigo: cod_team,
      fecha_ini_calidad: fecha_ini_calidad,
    };
  } else {
    console.log("Error al enviar Multi Work");
    return;
  }

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok" || response.data.status === "success") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Actualiza un incidente
 * @param {string} type - Tipo de pantalla
 * @param {string} typeConnect - Tipo de conexión
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @param {string} usuario - Usuario
 * @param {string} fecha_ini - Fecha de inicio
 * @param {number} cantidad_incidencia - Cantidad de incidencia
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const updateIncident = async (
  type,
  typeConnect,
  currentScreenId,
  po,
  mo,
  usuario,
  fecha_ini,
  cantidad_incidencia
) => {
  const queryData = {
    screen: type,
    action: typeConnect,
    query_type: currentScreenId,
    po: po,
    mo: mo,
    usuario: usuario,
    fecha_ini: fecha_ini,
    cantidad_incidencia: cantidad_incidencia,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok" || response.data.status === "success") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta línea de calidad
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @param {string} PO - Purchase Order
 * @param {string} MO - Manufacturing Order
 * @param {string} usuario - Usuario
 * @param {string} equipo - Equipo
 * @param {string} fechaIni - Fecha de inicio
 * @param {string} tipo_tiempo - Tipo de tiempo
 * @param {boolean} cvdChecked - CVD verificado
 * @param {number} finalCvdNumber - Número final CVD
 * @param {boolean} finalLgdChecked - LGD verificado
 * @param {number} cantidadPiezas - Cantidad de piezas
 * @param {number} pesoPieza - Peso de la pieza
 * @param {boolean} incidenciaChecked - Incidencia verificada
 * @param {number} finalCantidadIncidencia - Cantidad final de incidencias
 * @param {string} finalSelectedIncidencia - Incidencia seleccionada
 * @param {string} comentario - Comentario
 * @param {number} finalLGDNumber - Número final LGD
 * @param {string} usedPasswordName - Nombre de contraseña usada
 * @param {string} nameResponsable - Nombre del responsable
 * @param {number} pesoTeorico - Peso teórico
 * @param {number} variacionPorcentaje - Variación porcentual
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertLineaCalidad = async (
  currentScreenId,
  typeConnect,
  PO,
  MO,
  usuario,
  equipo,
  fechaIni,
  tipo_tiempo,
  cvdChecked,
  finalCvdNumber,
  finalLgdChecked,
  cantidadPiezas,
  pesoPieza,
  incidenciaChecked,
  finalCantidadIncidencia,
  finalSelectedIncidencia,
  comentario,
  finalLGDNumber,
  usedPasswordName,
  nameResponsable,
  pesoTeorico,
  variacionPorcentaje
) => {
  const queryData = {
    query_type: currentScreenId,
    action: typeConnect,
    po: PO,
    mo: MO,
    user: usuario,
    team: equipo,
    fechaIni: fechaIni,
    tipo_tiempo: tipo_tiempo,
    CVD: cvdChecked,
    CVDNumber: finalCvdNumber,
    LGD: finalLgdChecked,
    cantidad: cantidadPiezas,
    pesoTerm: pesoPieza,
    incidencia: incidenciaChecked,
    cantidad_incidencia: finalCantidadIncidencia,
    tipoIncidencia: finalSelectedIncidencia,
    finalLGDNumber: finalLGDNumber,
    comentario: comentario,
    auth: usedPasswordName,
    authName: nameResponsable,
    pesoTeorico: pesoTeorico,
    variacionPorcentaje: variacionPorcentaje,
  };
  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    let responseData = response.data;

    if (typeof responseData === 'string' && responseData.includes('{')) {
      try {

        const jsonStart = responseData.indexOf('{');
        const jsonString = responseData.substring(jsonStart);
        responseData = JSON.parse(jsonString);
      } catch (parseError) {
        console.error("Error al parsear JSON de la respuesta:", parseError);
        return false;
      }
    }

    if (responseData.status === "ok" || responseData.status === "success") {
      return responseData.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta término de calidad
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @param {string} usuario - Usuario
 * @param {string} equipo - Equipo
 * @param {string} item - Item
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertQualityTerm = async (
  currentScreenId,
  typeConnect,
  usuario,
  equipo,
  item
) => {
  const queryData = {
    query_type: currentScreenId,
    action: typeConnect,
    usuario: usuario,
    equipo: equipo,
    item: item,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok" || response.data.status === "success") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta tiempo de incidencias de calidad
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @param {string} tipoCrono - Tipo de cronómetro
 * @param {string} data - Datos
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertTimeIncidencesQuality = async (
  currentScreenId,
  typeConnect,
  tipoCrono,
  data
) => {
  const userData = {
    query_type: currentScreenId,
    action: typeConnect,
    query_param: tipoCrono,
    info: data,
  };

  try {
    const response = await axios.post(URL, qs.stringify(userData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.error(
        "Error en la respuesta del servidor:",
        response.data.message
      );
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
